import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    main: {
      paddingTop: theme.spacing(4),
      minHeight: '0',
      display: 'flex',
      flexDirection: 'column',

      flex: 1,

      '& > div:first-child': {
        minHeight: '0',
        overflowY: 'auto',

        '& .MuiTypography-h4': {
          color: theme.palette.text.secondary,
          fontWeight: 500,
          margin: theme.spacing(1, 0, 2, 0),
        },
      },
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1.5rem',
      paddingBottom: theme.spacing(3),

      '& label': {
        minHeight: '80px',
      },

      '& .MuiTypography-h3': {
        maxWidth: '100%',

        '& span': {
          color: theme.palette.text.primary,
        },
      },
      '& .MuiTypography-body1': {
        fontSize: '1.2rem',
        fontWeight: 600,
      },
    },
    buttonContainer: {
      marginTop: 'auto',

      '& > div': {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '1rem 0',

        '& > button': {
          width: 'auto',
          height: 'auto',
          margin: '0',
          padding: '1rem 1.5rem',
          minWidth: '10rem',
        },
      },
    },
  }),
)
